import { wtClientApi } from 'api/clients';

import type { GenericResponse } from 'commons/modules/generic-response';

import {
  ApiResponse,
  adaptApiToGenericResponse,
  adaptErrorToGenericResponse,
} from '../shared';

import { mapBankerContractToDto } from './mappers';
import type { BankerContract } from './models';

const CLIENTS_PATH = '/management/clients';

export const updateClientContractBanker = async (
  contract: BankerContract,
): Promise<GenericResponse<ApiResponse<void>>> => {
  try {
    const body = mapBankerContractToDto(contract);
    const response = await wtClientApi.put<ApiResponse<void>>(
      CLIENTS_PATH,
      body,
    );

    return adaptApiToGenericResponse(response.data, response.status);
  } catch (error: any) {
    return adaptErrorToGenericResponse(
      error,
      'Ocurrió un error al asignar el representante legal',
    );
  }
};
